/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RequestUpdateAmazonItemsStatusRequest
 */
export interface RequestUpdateAmazonItemsStatusRequest {
    /**
     *
     * @type {Array<number>}
     * @memberof RequestUpdateAmazonItemsStatusRequest
     */
    ids: Array<number>;
    /**
     *
     * @type {number}
     * @memberof RequestUpdateAmazonItemsStatusRequest
     */
    status: number;
    /**
     *
     * @type {number}
     * @memberof RequestUpdateAmazonItemsStatusRequest
     */
    userId: number;
    /**
     *
     * @type {number}
     * @memberof RequestUpdateAmazonItemsStatusRequest
     */
    tenantId: number;
}

/**
 * Check if a given object implements the RequestUpdateAmazonItemsStatusRequest interface.
 */
export function instanceOfRequestUpdateAmazonItemsStatusRequest(value: object): value is RequestUpdateAmazonItemsStatusRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function RequestUpdateAmazonItemsStatusRequestFromJSON(json: any): RequestUpdateAmazonItemsStatusRequest {
    return RequestUpdateAmazonItemsStatusRequestFromJSONTyped(json, false);
}

export function RequestUpdateAmazonItemsStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdateAmazonItemsStatusRequest {
    if (json == null) {
        return json;
    }
    return {

        'ids': json['ids'],
        'status': json['status'],
        'userId': json['userId'],
        'tenantId': json['tenantId'],
    };
}

export function RequestUpdateAmazonItemsStatusRequestToJSON(json: any): RequestUpdateAmazonItemsStatusRequest {
    return RequestUpdateAmazonItemsStatusRequestToJSONTyped(json, false);
}

export function RequestUpdateAmazonItemsStatusRequestToJSONTyped(value?: RequestUpdateAmazonItemsStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'ids': value['ids'],
        'status': value['status'],
        'userId': value['userId'],
        'tenantId': value['tenantId'],
    };
}
